import React, { useState, useEffect } from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DefaultList from './default';
import { RoleType } from './types';
import { XTabNav } from '@/components/xqxc_ui';
import { setBreadcrumbPaths } from '@/reducers/home/actions';
import RefundDeposit from './refundDeposit';
import ButtonPerssion from '@/routes/ButtonPerssion';

const tabList = [
    { id: RoleType.rider, label: '骑士', authCode: 'finance/paymanage/qs' },
    { id: RoleType.agent, label: '经纪人', authCode: 'finance/paymanage/jjr' },
    { id: RoleType.transport, label: '站点', authCode: 'finance/paymanage/zd' },
    { id: RoleType.refundDeposit, label: '退押金', authCode: 'finance/paymanage/tbzj' },
];

const PayManage = (props) => {

    const [curTabID, setCurTabID] = useState(RoleType.refundDeposit);

    useEffect(() => {
        props.setBreadcrumbPaths(props.match);
        if (props.history.location.curTabID) {
            setCurTabID(props.history.location.curTabID);
        }
    }, []);

    return (
        <div className={styles.flexBoxContainer}>
            <div className={styles.tabBox}>
                {tabList.map(v=>{
                    return (<ButtonPerssion code={v.authCode}  key={v.id}><div key={v.id} onClick={()=>{setCurTabID(v.id);}} className={`${styles.tab} ${curTabID == v.id ? styles.active : ''}`}>{v.label}</div></ButtonPerssion>);
                })}
            </div>
            {curTabID ? (
                curTabID == RoleType.refundDeposit ? <RefundDeposit   {...props}  /> : <DefaultList key={curTabID} curTabID={curTabID}  {...props} />
            ) : null}
            
        </div>
    );
};

PayManage.propTypes = {
    match: PropTypes.object,
    history: PropTypes.object,//路由对象
    setBreadcrumbPaths: PropTypes.func
};

export default connect(null, { setBreadcrumbPaths })(PayManage);